/**
 * Issue Bottom Sheet Component (Web Stub)
 *
 * On web platforms, we use IssuePopover instead.
 * This stub returns null for Metro resolution compatibility.
 */

import React from 'react';
import type { IssueBottomSheetProps } from './types';

/**
 * IssueBottomSheet - Web stub (unused on desktop)
 */
export function IssueBottomSheet(_props: IssueBottomSheetProps) {
  // Web uses IssuePopover, not bottom sheet
  return null;
}

export default IssueBottomSheet;
